export default __webpack_public_path__ + "static/media/img6.96ae024b.png";